var m = require('mithril');
var go = require('gojs');
var edit = require('../../layout/components/edit');
var diagramConfiguration = require('../components/diagram/diagramConfiguration');
var loaders = require('../../layout/components/loaders');
var serviceTaxonomy = require('../../service/serviceTaxonomy');

var diagramOnMap = {
  oninit: function(vnode) {
    var ctrl = this;
    ctrl.map = vnode.attrs.parentCtrl.map;
    ctrl.equipmentRecord = vnode.attrs.equipmentRecord;
    ctrl.nodeEquipmentArray = [];
    ctrl.linkFeedsDataArray = [];
    ctrl.myUpdatingGoJS = false;  // prevent modifying data.latlong properties upon Leaflet "move" events

    ctrl.nodeEquipmentArray = (ctrl.equipmentRecord().out_hasEquipment || []).map(hasComponentEdge => {
      let node = {
        category: 'Equipment',
        class: hasComponentEdge.in['@class'],
        key: hasComponentEdge.in['@rid'],
        name: hasComponentEdge.in['name'],
        linkKey: hasComponentEdge['@rid'],
        linkCategory: hasComponentEdge['@class'],
        leftArray: [],
        rightArray: [],
        topArray: [],
        bottomArray: [],
        centerArray: [],
        datasetsRids: (hasComponentEdge.in.out_Contains || []).map(c => c.in['@rid']),
        data: { ...hasComponentEdge.in.data },        
      };

      if (hasComponentEdge.in.latitude && hasComponentEdge.in.longitude) {
        node.latlong = [hasComponentEdge.in.latitude, hasComponentEdge.in.longitude]
      }

      if (hasComponentEdge.in.svgConverted) {
        node.svgConverted = hasComponentEdge.in.svgConverted;
      }
      
      if (hasComponentEdge.in.svg) {
        node.svg = hasComponentEdge.in.svg;
      }

      if (hasComponentEdge.in.ports) {
        node.ports = hasComponentEdge.in.ports;
        Object.values(hasComponentEdge.in.ports).forEach(port => {
          if (port.position == 'left') {
            node.leftArray.push({ portColor: diagramConfiguration.findPortColor(serviceTaxonomy.getServiceClass(port)), portId: port.name, type: edit.vm.editing() ? port.type : false, category: serviceTaxonomy.getServiceClass(port) })
          }
          if (port.position == 'right') {
            node.rightArray.push({ portColor: diagramConfiguration.findPortColor(serviceTaxonomy.getServiceClass(port)), portId: port.name, type: edit.vm.editing() ? port.type : false, category: serviceTaxonomy.getServiceClass(port) })
          }
          if (port.position == 'top') {
            node.topArray.push({ portColor: diagramConfiguration.findPortColor(serviceTaxonomy.getServiceClass(port)), portId: port.name, type: edit.vm.editing() ? port.type : false, category: serviceTaxonomy.getServiceClass(port) })
          }
          if (port.position == 'bottom') {
            node.bottomArray.push({ portColor: diagramConfiguration.findPortColor(serviceTaxonomy.getServiceClass(port)), portId: port.name, type: edit.vm.editing() ? port.type : false, category: serviceTaxonomy.getServiceClass(port) })
          }
          if (port.position == 'center') {
            node.centerArray.push({ portColor: diagramConfiguration.findPortColor(serviceTaxonomy.getServiceClass(port)), portId: port.name, type: edit.vm.editing() ? port.type : false, category: serviceTaxonomy.getServiceClass(port) })
          }
        })
      }

      if (hasComponentEdge.in.showInSummary) {
        node.showInSummary = hasComponentEdge.in.showInSummary;
      }
      

      hasComponentEdge.in['diagramData'] && hasComponentEdge.in['diagramData'][ctrl.equipmentRecord()['@rid']] && hasComponentEdge.in['diagramData'][ctrl.equipmentRecord()['@rid']].width ? node.width = hasComponentEdge.in['diagramData'][ctrl.equipmentRecord()['@rid']].width : '';
      hasComponentEdge.in['diagramData'] && hasComponentEdge.in['diagramData'][ctrl.equipmentRecord()['@rid']] && hasComponentEdge.in['diagramData'][ctrl.equipmentRecord()['@rid']].height ? node.height = hasComponentEdge.in['diagramData'][ctrl.equipmentRecord()['@rid']].height : '';
      hasComponentEdge.in['diagramData'] && hasComponentEdge.in['diagramData'][ctrl.equipmentRecord()['@rid']] && hasComponentEdge.in['diagramData'][ctrl.equipmentRecord()['@rid']].loc ? node.loc = hasComponentEdge.in['diagramData'][ctrl.equipmentRecord()['@rid']].loc : '';

      return node;
    });
    (ctrl.equipmentRecord()['@class'] == 'System' ? ctrl.equipmentRecord().out_hasEquipment : ctrl.equipmentRecord().out_hasComponent || []).forEach(hasComponentEdge => {
      let childEquipmentRecord = hasComponentEdge.in;
      (childEquipmentRecord.out_Feeds || []).forEach(feedsEdge => {
        let linkFeedsData = {
          class: feedsEdge['@class'],
          category: serviceTaxonomy.getServiceClass(feedsEdge),
          key: feedsEdge['@rid'],
          from: feedsEdge.out,
          to: feedsEdge.toNodePort ? feedsEdge.toNodePort : feedsEdge.in,
          fromPortId: feedsEdge.fromPortId,
          toPortId: feedsEdge.toPortId,
          diagramData: feedsEdge.diagramData,
          linkColor: diagramConfiguration.findPortColor(serviceTaxonomy.getServiceClass(feedsEdge))
        }
        let linkDashPattern = diagramConfiguration.findLinkDashArray(serviceTaxonomy.getServiceClass(feedsEdge));
        if (linkDashPattern) {
          linkFeedsData.dashPattern = linkDashPattern;
        }
        feedsEdge['diagramData'] && feedsEdge['diagramData'][ctrl.equipmentRecord()['@rid']] && feedsEdge['diagramData'][ctrl.equipmentRecord()['@rid']].route ? linkFeedsData.route = feedsEdge['diagramData'][ctrl.equipmentRecord()['@rid']].route : '';
        ctrl.linkFeedsDataArray.push(linkFeedsData)
      })
    });
  },
  oncreate: function(vnode) {
    var ctrl = this;

    const $ = go.GraphObject.make;
    ctrl.myDiagram = new go.Diagram("myDiagramDiv", {
      "InitialLayoutCompleted": e => ctrl.updatePosition(),
      "dragSelectingTool.isEnabled": false,
      "animationManager.isEnabled": false,
      scrollMode: go.Diagram.InfiniteScroll,
      allowZoom: false,
      allowHorizontalScroll: false,
      allowVerticalScroll: false,
      hasHorizontalScrollbar: false,
      hasVerticalScrollbar: false,
      padding: 0,
      defaultCursor: "default",
      "toolManager.hoverDelay": 100,  // how quickly tooltips are shown
      "undoManager.isEnabled": true,
      "ModelChanged": e => {
        if (e.change === go.ChangedEvent.Transaction &&
          (e.propertyName === "FinishedUndo" || e.propertyName === "FinishedRedo")) {
          setTimeout(() => ctrl.updateNodes());
        }
      },
    });


    ctrl.convertRouteToPoints = function (route, link) {
      console.log(route)
      const points = new go.List();
      route.forEach(p => {
        const pos = ctrl.map.project([p.lat, p.long], ctrl.map.getZoom());
        points.add(new go.Point(pos.x, pos.y));
      });
      return points;
    }

    ctrl.convertPointsToRoute = function (points, data, model) {
      if (ctrl.myUpdatingGoJS) {
        return data.route; // no-op
      } else {
        const route = [];
        console.log(ctrl.map.getZoom())
        points.each(p => {
          const ll = ctrl.map.unproject(L.point(p.x, p.y), ctrl.map.getZoom());
          route.push({ lat: ll.lat, long: ll.lng  });
        });
        model.set(data, "route", route);
        return route;
      }
    }


    ctrl.myDiagram.nodeTemplate =  $(go.Node, "Table",
    {
      locationSpot: go.Spot.Center,
    },
    new go.Binding("location", "latlong", data => {
      const pos = ctrl.map.project(data, ctrl.map.getZoom());
      return new go.Point(pos.x, pos.y);
    }).makeTwoWay((pt, data) => {
      if (ctrl.myUpdatingGoJS) {
        return data.latlong; // no-op
      } else {
        const ll = ctrl.map.unproject(L.point(pt.x, pt.y), ctrl.map.getZoom());
        return [ll.lat, ll.lng];
      }
    }),
    // the body
    $(go.Panel, "Auto",
      {
        row: 1, column: 1, name: "BODY",
        stretch: go.GraphObject.Fill
      },
          $(go.Shape, "Rectangle", {
          fill: $(go.Brush, "Linear", { 0.0: "#2a2a2a", 1.0: "white", start: go.Spot.Bottom, end: go.Spot.Top }),
          stroke: "black",
          strokeWidth: 2,
          minSize: new go.Size(((diagramConfiguration.calculateCellWidth()* 7) - 2), ((diagramConfiguration.calculateCellHeight() * 5) - 2)),
          maxSize: new go.Size(((diagramConfiguration.calculateCellWidth()* 7) - 2), ((diagramConfiguration.calculateCellHeight() * 5) - 2))
        }),
      ),
    );    
    ctrl.myDiagram.model = new go.GraphLinksModel(
      ctrl.nodeEquipmentArray,
      ctrl.linkFeedsDataArray
    );

    ctrl.myDiagram.linkTemplate = $(go.Link,
      {
        layerName: 'Background',
        adjusting: go.Link.Stretch,
        reshapable: true, 
        resegmentable: true,
        toolTip: $('ToolTip', $(go.TextBlock, { margin: 4, textAlign: 'center' }, new go.Binding('text', '', (d) => `${d.from} -- ${d.to}`))),
      },
      new go.Binding("points", "route", ctrl.convertRouteToPoints).makeTwoWay(ctrl.convertPointsToRoute),
      $(go.Shape, { strokeWidth: 3, stroke: 'rgba(100,100,255,.7)' })
    );

    ctrl.updateNodes =  function() {  // called when zoom level has changed
      ctrl.myUpdatingGoJS = true;
      ctrl.myDiagram.commit(diag => {
        diag.nodes.each(n => n.updateTargetBindings("latlong")); // without virtualization this can be slow if there are many nodes
        diag.links.each(n => {n.updateTargetBindings("route")});
      }, null);
      ctrl.myUpdatingGoJS = false;
    }

    ctrl.updatePosition = function() {  // called when map has been panned (i.e. top-left corner is at a different latlong)
      const mapb = ctrl.map.getBounds();
      const pos = ctrl.map.project([mapb.getNorth(), mapb.getWest()], ctrl.map.getZoom());
      ctrl.myDiagram.position = new go.Point(pos.x, pos.y);
    }

    ctrl.myDiagram.toolManager.draggingTool.doActivate = function() {
      ctrl.map.dragging.disable();
      go.DraggingTool.prototype.doActivate.call(this);
    }

    ctrl.myDiagram.toolManager.draggingTool.doDeactivate = function() {
      ctrl.map.dragging.enable();
      go.DraggingTool.prototype.doDeactivate.call(this);
    }
    
    ctrl.myDiagram.addDiagramListener("LinkReshaped", function (e) {
      let routeArray = e.subject.points.map(p => ctrl.map.unproject({ x: p.x, y: p.y }, ctrl.map.getZoom()));
      let latlngArray = routeArray.s.map(p => ({lat: p.lat, long: p.lng}));
      if (e.subject.data.class == 'Feeds') {
        let body = {};
        body.diagramData = {...e.subject.data.diagramData, [ctrl.equipmentRecord()['@rid']]: {
          route: latlngArray,
        }};

        loaders.requestWithLoader({
          loader: 'main',
          url: `/api/v1/${e.subject.data.class.toLowerCase()}/${e.subject.data.key.slice(1)}`,
          method: 'PUT',
          body: body
        })
      }
    });

    ctrl.map.on("zoomend", ctrl.updateNodes);
    ctrl.map.on("move", ctrl.updatePosition);
    ctrl.map.on("moveend", ctrl.updatePosition);
    
    ctrl.myDiagram.model = new go.GraphLinksModel(
      ctrl.nodeEquipmentArray,
      ctrl.linkFeedsDataArray
    );
  },
  onupdate: function(vnode) {
    var ctrl = this;
  },
  view: function(vnode) {
    return m('div.w-100.h-100', {id: 'myDiagramDiv', style: {'z-index': '701'}} )
  }
}

module.exports = diagramOnMap;